export default function MediaStudio ({country}: { country: 'south-africa' | 'nigeria' }) {
  return (
    <div className="App game-studio media-studio">
        <a href={`/${country}`} className="game-back-link">&larr; Back to TV Guide</a>
        <p>Fresh content, straight to your screen — editorials, satire and more. Best experienced on mobile.</p>
        <h1>Media Studio</h1>
        <div className="game-cards">
            <a className="game-card media-card media-card-comic" href={`/political-comic/${country}`}>
                <div className="game-card-icon">🗞️</div>
                <h2 className="game-card-title">Political Comic Strip</h2>
                <div className="game-card-version">Daily &middot; Editorial satire</div>
            </a>
            <div className="game-card media-card media-card-soon">
                <div className="game-card-icon">🎬</div>
                <h2 className="game-card-title">Coming soon</h2>
                <div className="game-card-version">More media &middot; In the works</div>
            </div>
        </div>
    </div>
  );
}
